/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Admin_Dashboard_Invoice_Tags_Time_PassInputs */

const en_admin_dashboard_invoice_tags_time_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Time_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time Passes`)
};

const de_admin_dashboard_invoice_tags_time_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Time_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeit-Pässe`)
};

const es_admin_dashboard_invoice_tags_time_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Time_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pases de tiempo`)
};

const fr_admin_dashboard_invoice_tags_time_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Time_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass de temps`)
};

const nl_admin_dashboard_invoice_tags_time_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Time_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tijdspassen`)
};

const it_admin_dashboard_invoice_tags_time_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Time_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pass a tempo`)
};

const pt_br2_admin_dashboard_invoice_tags_time_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Time_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Passes de tempo`)
};

const pl_admin_dashboard_invoice_tags_time_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Time_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Karnety czasowe`)
};

const hu_admin_dashboard_invoice_tags_time_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Time_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Idő bérletek`)
};

const ro_admin_dashboard_invoice_tags_time_pass = /** @type {(inputs: Admin_Dashboard_Invoice_Tags_Time_PassInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pase de Timp`)
};

/**
* | output |
* | --- |
* | "Time Passes" |
*
* @param {Admin_Dashboard_Invoice_Tags_Time_PassInputs} inputs
* @param {{ locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }} options
* @returns {LocalizedString}
*/
const admin_dashboard_invoice_tags_time_pass = /** @type {((inputs?: Admin_Dashboard_Invoice_Tags_Time_PassInputs, options?: { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Admin_Dashboard_Invoice_Tags_Time_PassInputs, { locale?: "en" | "de" | "es" | "fr" | "nl" | "it" | "pt-BR" | "pl" | "hu" | "ro" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_admin_dashboard_invoice_tags_time_pass(inputs)
	if (locale === "de") return de_admin_dashboard_invoice_tags_time_pass(inputs)
	if (locale === "es") return es_admin_dashboard_invoice_tags_time_pass(inputs)
	if (locale === "fr") return fr_admin_dashboard_invoice_tags_time_pass(inputs)
	if (locale === "nl") return nl_admin_dashboard_invoice_tags_time_pass(inputs)
	if (locale === "it") return it_admin_dashboard_invoice_tags_time_pass(inputs)
	if (locale === "pt-BR") return pt_br2_admin_dashboard_invoice_tags_time_pass(inputs)
	if (locale === "pl") return pl_admin_dashboard_invoice_tags_time_pass(inputs)
	if (locale === "hu") return hu_admin_dashboard_invoice_tags_time_pass(inputs)
	return ro_admin_dashboard_invoice_tags_time_pass(inputs)
});
export { admin_dashboard_invoice_tags_time_pass as "admin.dashboard.invoice_tags.time_pass" }